import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_acea3iv0: FaireBrandEntity = {
  token: "b_acea3iv0",
  type: "brand",
  name: "Blind Barber",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/44161c17b3fb54a5b3911da12ac8cad4d21717278a8fd08368e08d5111d43da2/1563479455.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/578f4b2d5ee7462960ecefacd93ca8afa6c0e0fd164d14cb54cd2994005bd8fd.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/44161c17b3fb54a5b3911da12ac8cad4d21717278a8fd08368e08d5111d43da2/1563479455.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/578f4b2d5ee7462960ecefacd93ca8afa6c0e0fd164d14cb54cd2994005bd8fd.jpeg",
  location: "New York City, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 33,
  isTopShop: true,
  isInsider: false,
  description:
    "It used to be that the barbershop was't just a place to get a haircut or shave, it was the hub of community - where people got together to bond, socialize and exchange ideas.  With the goal of bringing this camaraderie back in style,  a barbershop and parlor with locations in New York, NY, Los Angeles, CA, and Brooklyn, NY, has created a concept that goes well beyond cuts, shaves and cocktails. By cultivating a men's grooming line, voice and destinations. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:07.314Z",
    importedBy: "entity-db-cli",
  },
};
